<img *ngFor="let image of images" [src]="image" width="1" height="1" alt="" />
